import { Link } from "react-router-dom";
import { useState } from "react"
import { MdNavigateBefore } from "react-icons/md";

import { MdOutlineNavigateNext } from "react-icons/md";

import { SellPumpToken } from "../Transactions";
export default function BotTrades({ userTrades, sellMarket,realtimeMarketCaps}) {


  let mints = Object.keys(userTrades)

  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 5 // Number of items per page

  // Calculate the index of the first and last item for the current page
  const lastIndex = currentPage * itemsPerPage
  const firstIndex = lastIndex - itemsPerPage
  const currentTokens = mints.slice(firstIndex, lastIndex)

  // Calculate total number of pages
  const totalPages = Math.ceil(mints.length / itemsPerPage)

  // Handlers for pagination controls
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const goToFirstPage = () => {
    setCurrentPage(1)
  }

  const goToLastPage = () => {
    setCurrentPage(totalPages)
  }


  const handleSell = (mint) => {
    const token = userTrades[mint]
 
      sellMarket(token,"sell")

  }

  // console.log(us)



  return (

    <div className={` max-w-[100%]  space-y-3 overflow-x-scroll `}>
      <h1 className="text-neutral-400  px-1 border-b border-yellow-500/10 rounded ">Bot Trades :</h1>
      <table className="  rounded-lg outline outline-yellow-500/10 outline-1   overflow-hidden  w-full h-max ">
        <thead className=" bg-neutral-900  ">

          <tr className="text-yellow-600 text-left font-semibold capitalize text-xs rounded-lg ">
            <th className="p-3 text-xs">Name</th>
            <th className="p-3 text-xs">MC</th>
            <th className="p-3 text-xs">current MC</th>
            <th className="p-3 text-xs">Symbol</th>
            <th className="p-3 text-xs">Transaction</th>
            <th className="p-3 text-xs">pump</th>
          </tr>
        </thead>

        <tbody className=" !overflow-y-scroll">


          {
            currentTokens?.map((mint, i) => {
              return (
                <tr key={'table' + i} className="text-neutral-300  border-b border-neutral-800  hover:bg-neutral-400/10 transition-all h-14 " >
                  <td className="p-3 text-xs text-yellow-500 hover:text-pink-500 truncate">
                    <Link to={`https://pump.fun/coin/${mint}`} target="_blank">
                      {userTrades[mint].name}
                    </Link>
                  </td>
                  <td className="p-3 text-xs">{Number(userTrades[mint]?.marketCapSol).toFixed(2)}</td>
                  <td className="p-3 text-xs">{Number(realtimeMarketCaps[mint]).toFixed(2) || "N/A"}</td>
                  <td className="p-3 text-xs">{userTrades[mint]?.symbol}</td>
                  <td className="p-1 text-xs  "> <p className="p-1 text-xs truncate  border border-neutral-800 w-20 rounded-lg px-5 bg-neutral-800 ">{userTrades[mint]?.serverTransaction}</p>   </td>
                  <td className="p-1 text-xs  "> <button className="py-1 w-full px-2 bg-yellow-500 hover:bg-red-500 text-black rounded" onClick={() => handleSell(mint)}>Sell</button>  </td>
                </tr>
                // <tr key={'table'+i} className="text-neutral-400 flex gap-3 justify-between w-full border-b border-neutral-800 text-wrap my-1  ">
                //     <p className='capitalize truncate text-xs text-wrap'>{token.network}</p>
                //     <p className='text-yellow-600 truncate font-bold  text-xs w-40 md:w-auto text-right '  >{token.name}</p>
                // </tr>
              )
            })
          }
        </tbody >
      </table>

      {mints.length > itemsPerPage &&
        <div className="flex justify-start gap-5 items-center mt-4">

          <button disabled={currentPage === 1} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToPrevPage} >
            <MdNavigateBefore className="text-2xl" />
          </button>
          <button disabled={currentPage === totalPages} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToNextPage}>
            <MdOutlineNavigateNext className="text-2xl" />
          </button>

          <span className="p-2 text-white">Page {currentPage} of {totalPages}</span>

        </div>}




    </div>
  )


}